import { Menu } from "@/types/menu";

export const getBaseMenuData = (): Menu[] => [
  {
    id: 1,
    title: "Home",
    path: "/#home",
    newTab: false,
  },
  {
    id: 2,
    title: "About",
    path: "/#about",
    newTab: false,
  },
  {
    id: 3,
    title: "Expertise",
    newTab: false,
    submenu: [
      {
        id: 41,
        title: "AI Services",
        path: "/ai-services",
        newTab: false,
      },
      {
        id: 42,
        title: "Facebook API",
        path: "/facebook-api",
        newTab: false,
      },
      {
        id: 43,
        title: "Shopify App Development",
        path: "/shopify-app-development",
        newTab: false,
      },
      {
        id: 44,
        title: "WhatsApp Business API",
        path: "/whatsapp-business-api",
        newTab: false,
      },
    ],
  },
  {
    id: 5,
    title: "Blog",
    path: "/blog",
    newTab: false,
  },
  {
    id: 6,
    title: "Contact",
    path: "/#contact",
    newTab: false,
  },
];

export const getProjectsMenuItem = (): Menu => ({
  id: 4,
  title: "Projects",
  path: "/projects",
  newTab: false,
});

// Default menu data without projects (for backward compatibility)
const menuData: Menu[] = getBaseMenuData();
export default menuData;
